import { Directive, input } from '@angular/core';

import { AcceptedFileTypesService } from './accepted-file-types.service';
import type { FileTypesCategory } from './accepted-file-types.types';

@Directive({
  selector: '[rtAcceptedFileTypes]',
  standalone: true,
  host: {
    '[accept]': 'helperService.byCategoryAsString[category()]',
  },
})
export class AcceptedFileTypesDirective {
  public readonly category = input<FileTypesCategory>(undefined!, { alias: 'rtAcceptedFileTypes' });

  constructor(public helperService: AcceptedFileTypesService) {}
}
